import { EnrichStore } from '@move-frontend/utils';
export class FlightEnrichStore extends EnrichStore {
}
//# sourceMappingURL=FlightEnrichStore.js.map